module.exports = __webpack_public_path__ + "media/custom/images/pocstock-about-us-collage-2-71d5346b1ea3383b999fe0871da6e288.png";